import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Snow Leopards in mah rooms!",
  "description": "",
  "published": "2009-09-02T00:00:00.000Z",
  "redirect_from": ["/blog/snow-leopards-in-mah-rooms/swizec/713"],
  "categories": "Apple, Operating system, review, Time Machine, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://www.flickr.com/photos/75567359@N00/3874419893"
          }}><img parentName="a" {...{
              "src": "https://farm3.static.flickr.com/2424/3874419893_60855d4ea2_m.jpg",
              "alt": "Snow Leopard",
              "title": "Snow Leopard"
            }}></img></a></p>
        <p parentName="li">{`Image by `}<a parentName="p" {...{
            "href": "http://www.flickr.com/photos/75567359@N00/3874419893"
          }}>{`mwboeckmann`}</a>{` via Flickr`}</p>
      </li>
    </ul>
    <p>{`Yesterday I finally installed my `}<strong parentName="p">{`pirated`}</strong>{` version of `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Snow_Leopard",
        "title": "Snow Leopard"
      }}>{`Snow Leopard`}</a>{` and thus bringing yet another large kitten into my bedroom. It was a shame that I had to go out and buy a dual layer DVD, but such is life when no external hard drives are available to burn the .dmg to and install from there.`}</p>
    <p>{`So far I must say I haven't noticed much difference between Leopard and its fluffier cousin. It's obviously more responsive, something I'm particularly fond of since the old install was getting a bit sluggish for some reason. The fact they managed to trim the operating system's footpring by almost ten gigs is simply mind blowingly awesome as well. But as a certain mate put it, that only means the previous version had a serious flaw.`}</p>
    <p>{`Another thing I really love about the new `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Operating_system",
        "title": "Operating system"
      }}>{`OS`}</a>{` is that ... I don't notice it's there! At all! When you move from XP to `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Windows_Vista",
        "title": "Windows Vista"
      }}>{`Vista`}</a>{`, Vista to 7, everything is so vastly different and horrible. Even moving from one `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Ubuntu",
        "title": "Ubuntu"
      }}>{`Ubuntu`}</a>{` version to another can be quite a shattering experience. But updating to Snow Leopard ... nothing. The installer made sure to transfer all of my `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Time_Machine_%28Apple_software%29",
        "title": "Time Machine (Apple software)"
      }}>{`Time Machine`}</a>{` backups and everything is as I left it. Down to the tinniest of settings. Awesome! Even all the software migrated properly :D`}</p>
    <p>{`But despite the update being quite unnoticable, there are small jars here and there. Things that aren't exactly as you'd expect and make you go "Whoa!". I think it's a bit of an `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Uncanny_valley",
        "title": "Uncanny valley"
      }}>{`uncanny valley`}</a>{` problem, the changes are so subtle you don't expect them and it makes you queasy.`}</p>
    <p>{`One such example is that dock menus are now black and transparent, wtf? It honestly startled me when I first saw that, simply wasn't expecting it. Another is that expose'd windows now get a jarringly fugly blue border around them upon mouse-over. Another wtf. The fact they now have their names spelled out under the screenshot is rather useless as well, makes 'em look like desktop icons ... but not quite! I preferred the old way when the window simply highlighted (became brighter) and there was no name, it's essentially usless information anyway.`}</p>
    <p>{`Perhaps the most noticable of changes is that everything, absolutely everything, is more saturated now. Can't quite say whether I like or dislike this GUI tweak ...`}</p>
    <p>{`PS: I only pirated because Apple is so stupid as to not sell their software in my market and, worse still, not allowing shops in nearby markets to ship to me. So fuck 'em.`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/76604000-2115-4661-8b2f-5b64fbd5afb8/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=76604000-2115-4661-8b2f-5b64fbd5afb8",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      